var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-station"},[_c('headline',[_vm._v(" "+_vm._s(_vm.$t('charging-point.charging-points'))+" ")]),_c('charging-point-list',{ref:"chargingPointList",attrs:{"locationId":_vm.location.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }